module.exports = __webpack_public_path__ + "img/p1_bg.bb4d38bd.jpg";